import Speech from "./Speech.vue";

const SpeechPlugin = {
    install(Vue) {
        Vue.component("speech-icon", Speech);
    },
};
export default SpeechPlugin;
